export const SHIFTS = [
  { key: "1st", label: "1st Shift", time: "07:00 – 15:30", sub: "Morning / Day Scan", badge: "bg-amber-50 text-amber-800 border-amber-200", dot: "#D97706" },
  { key: "2nd", label: "2nd Shift", time: "15:00 – 23:30", sub: "Evening / Trauma", badge: "bg-sky-50 text-sky-800 border-sky-200", dot: "#0284C7" },
  { key: "3rd", label: "3rd Shift", time: "23:00 – 07:30", sub: "Overnight / On-Call", badge: "bg-indigo-50 text-indigo-800 border-indigo-200", dot: "#4F46E5" },
];

export const SHIFT_ORDER = ["1st", "2nd", "3rd"];
export const SHIFT_COLORS = SHIFTS.reduce((acc, s) => { acc[s.key] = { badge: s.badge, dot: s.dot }; return acc; }, {});

export const DAYS = [
  { key: "mon", label: "Mon" },
  { key: "tue", label: "Tue" },
  { key: "wed", label: "Wed" },
  { key: "thu", label: "Thu" },
  { key: "fri", label: "Fri" },
  { key: "sat", label: "Sat" },
  { key: "sun", label: "Sun" },
];

export function mondayOf(date) {
  const d = new Date(date);
  const day = (d.getDay() + 6) % 7; // 0 = Monday
  d.setDate(d.getDate() - day);
  d.setHours(0, 0, 0, 0);
  return d;
}

export function isoDate(d) {
  return new Date(d).toISOString().slice(0, 10);
}

export function fmtDate(iso) {
  if (!iso) return "";
  const d = new Date(iso + "T00:00:00");
  return d.toLocaleDateString("en-US", { weekday: "short", month: "short", day: "numeric" });
}

export function addDays(date, n) {
  const d = new Date(date);
  d.setDate(d.getDate() + n);
  return d;
}

export function parseShiftTime(str) {
  if (!str) return { start: "", end: "" };
  const parts = str.split(/[–-]/).map((x) => x.trim());
  return { start: parts[0] || "", end: parts[1] || "" };
}

export const STATUS_STYLE = {
  approved: "bg-emerald-100 text-emerald-800 border-emerald-300",
  accepted: "bg-emerald-100 text-emerald-800 border-emerald-300",
  filled: "bg-emerald-100 text-emerald-800 border-emerald-300",
  pending: "bg-amber-100 text-amber-800 border-amber-300",
  open: "bg-cyan-100 text-cyan-900 border-cyan-300",
  rejected: "bg-rose-100 text-rose-800 border-rose-300",
};
